<template>
  <main id="form" class="relative z-40 missing">
    <NoticeView v-if="open" @close="open = false" />
    <img
      src="../assets/images/pepite1.png"
      class="sm:hidden w-[15vw] absolute top-[45px] -right-[3vw] rotate-[270deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[5vw] absolute top-[165px] left-[3vw] rotate-[20deg] z-50"
      style="align-items: center"
    />

    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute top-[395px] -left-[10px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/noisette.png"
      class="sm:hidden w-[10vw] absolute bottom-[15px] right-[20px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <img
      src="../assets/images/pepite2.png"
      class="sm:hidden w-[4vw] absolute -bottom-[20px] right-[15px] rotate-[20deg] z-50"
      style="align-items: center"
    />
    <div class="mt-28 md:mt-16 w-full text-white px-[12vw] sm:px-4">
      <h1 class="font-veneer text-3xl text-white text-center my-6">
        veuillez compléter les informations ci-dessous :
      </h1>
    </div>
    <Form
      class="px-[12vw] sm:px-4"
      v-if="_id && uid"
      id="monform"
      form_id="696669f88644bf8a91004693"
      :uid="uid"
      :submission_id="_id"
      server="https://api-gabarit.promo.dev"
      v-on:results="getResult"
      v-on:form_submit_loading="onLoading"
      :hideError="hiderror"
      @on_error="showErrorForm"
    />
  </main>
</template>
<script setup lang="ts">
import router from "@/router";
import axios from "axios";
import { ref, onMounted } from "vue";
import NoticeView from "@/components/NoticeView.vue";

const hiderror = ref(true);
const loading = ref(false);
const error = ref(false);
const _id = ref();
const uid = ref();
const open = ref(false);

const onLoading = () => {
  loading.value = true;
};

const showErrorForm = () => {
  loading.value = false;
  error.value = true;
};

const getResult = (result) => {
  if (result && result.status) {
    sessionStorage.clear();
    sessionStorage.setItem("status", "WIN2");
    router.push({ name: "done" });
  } else {
    alert("Une erreur est survenue, veuillez réessayer plus tard.");
  }
};

onMounted(async () => {
  try {
    setTimeout(() => {
      if (document.querySelector("#noticelink")) {
        document
          .querySelector("#noticelink")
          .addEventListener("click", (event) => {
            event.preventDefault();
            open.value = true;
          });
      }
    }, 1000);

    const currentRoute = router.currentRoute;
    console.log(currentRoute);
    if (currentRoute.params._id && currentRoute.params.uid) {
      _id.value = currentRoute.params._id;
      uid.value = currentRoute.params.uid;
    } else {
      const s_id = sessionStorage.getItem("_id");
      const s_uid = sessionStorage.getItem("uid");

      if (!s_id || !s_uid) {
        router.push("/");
      }
      _id.value = s_id;
      uid.value = s_uid;
    }

    if (!_id.value || !uid.value) {
      //router.push("/");
    }

    const { data: submission } = await axios.get(
      `https://api-gabarit.promo.dev/api/v2/submissions/${_id.value}?uid=${uid.value}`
    );

    if (!submission) {
      //  router.push("/");
    }
  } catch (e) {
    console.error(e);
  }
});
</script>
